import PracticeExamsPage from '../lcca/PracticeExams';
import { tracks } from '../tracks/config';

export default function LCPAAPracticeExamsPage() {
  return <PracticeExamsPage track={tracks.lcpaa} />;
}
